import {
  FETCH_CLIENTES_REQUEST,
  FETCH_CLIENTES_SUCCESS,
  FETCH_CLIENTES_FAILURE,
} from "../actions/clientes/types";

const initialState = { items: [], loading: false, error: null };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CLIENTES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_CLIENTES_SUCCESS:
      return { ...state, loading: false, items: Array.isArray(action.payload) ? action.payload : [], error: null };
    case FETCH_CLIENTES_FAILURE:
      return { ...state, loading: false, error: action.payload?.error ?? "Error desconocido" };
    default:
      return state;
  }
};

export default reducer;
